// extracted by mini-css-extract-plugin
module.exports = {"updateActionButton":"EditGlobalAlert_updateActionButton__3UJmQ","blurred":"EditGlobalAlert_blurred__PcC0y"};